import React from 'react';
import PropTypes from 'prop-types';

const FilterControls = ({
	hasSelectedUsers,
	hasSelectedProjects,
	loading,
	isDataStillUpdating,
	onLoadData,
	onResetFilters,
	showResetButton = true,
	hasLoadedData = false,
	filtersChanged = false,
}) => {
	const canLoadData = hasSelectedUsers && !loading && !isDataStillUpdating;

	return (
		<div className='flex items-center gap-3 mt-6 p-4 bg-gray-50 rounded-lg border'>
			<button
				onClick={onLoadData}
				className={`px-6 py-2 rounded-md font-medium ${
					canLoadData
						? 'bg-blue-600 hover:bg-blue-700 text-white'
						: 'bg-gray-300 text-gray-500 cursor-not-allowed'
				}`}
				disabled={!canLoadData}
			>
				{loading || isDataStillUpdating ? (
					<span className='flex items-center'>
						<span className='w-4 h-4 mr-2 border-2 border-white border-t-transparent rounded-full animate-spin'></span>
						Loading...
					</span>
				) : (
					'Load Data'
				)}
			</button>

			{showResetButton && (
				<button
					onClick={onResetFilters}
					className='px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-md'
					disabled={loading || isDataStillUpdating}
				>
					Reset Filters
				</button>
			)}

			{(loading || isDataStillUpdating) && (
				<button
					onClick={() => window.location.reload()}
					className='px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md'
				>
					Cancel
				</button>
			)}

			<div className='text-sm text-gray-600'>
				{!hasSelectedUsers && (
					<span className='text-yellow-600'>Please select at least one user</span>
				)}
				{hasSelectedUsers && !hasLoadedData && !hasSelectedProjects && (
					<span className='text-blue-600'>All projects will be included</span>
				)}
				{hasSelectedUsers && !hasLoadedData && hasSelectedProjects && (
					<span className='text-green-600'>Ready to load filtered data</span>
				)}
				{hasSelectedUsers && hasLoadedData && !filtersChanged && (
					<span className='text-gray-600'>Data is up to date</span>
				)}
				{hasSelectedUsers && hasLoadedData && filtersChanged && (
					<span className='text-green-600'>Ready to load filtered data</span>
				)}
			</div>
		</div>
	);
};

FilterControls.propTypes = {
	hasSelectedUsers: PropTypes.bool.isRequired,
	hasSelectedProjects: PropTypes.bool.isRequired,
	loading: PropTypes.bool.isRequired,
	isDataStillUpdating: PropTypes.bool.isRequired,
	onLoadData: PropTypes.func.isRequired,
	onResetFilters: PropTypes.func.isRequired,
	showResetButton: PropTypes.bool,
	hasLoadedData: PropTypes.bool,
	filtersChanged: PropTypes.bool,
};

export default FilterControls;
